var Filtres = function() {
    'use strict';

    var agenceSelectionnee;
    var $filtreAgence, $filtreDepartement, $filtreActif, $filtreArchive, $filtreStatut, $filtreOrigineCandidat,
        $filtreAgent, $filtreBailElec, $filtrePriorite, $filtreGliZelok, $filtreReseau;

    function init(pAgenceSelectionnee) {
        agenceSelectionnee = pAgenceSelectionnee;
        $filtreAgence      = $('#filtre-agence');
        $filtreDepartement = $('#filtre-departement');
        $filtrePriorite    = $('#filtre-priorite');
        $filtreAgent       = $('#filtre-agent');
        $filtreActif       = $('#filtre-actif');
        $filtreArchive     = $('#filtre-archive');
        $filtreStatut      = $('#filtre-statut');
        $filtreOrigineCandidat = $('#filtre-origine');
        $filtreBailElec    = $('#filtre-bailelec');
        $filtreGliZelok    = $('#filtre-glizelok');
        $filtreReseau      = $('#filtre-reseau');


        // filtre priorité
        if (sessionStorage['table-candidats-locataires.filtre-priorite']) {
            $filtrePriorite.val(sessionStorage['table-candidats-locataires.filtre-priorite']);
        }

        $filtrePriorite.on('change', function(evt) {
            sessionStorage['table-candidats-locataires.filtre-priorite'] = evt.target.value;
            $('table').bootstrapTable('refresh');
        });

        if (sessionStorage['table-candidats-locataires.filtre-departement']) {
            $filtreDepartement.val(sessionStorage['table-candidats-locataires.filtre-departement']);
        }

        // transforme le select agence en select + autocomplete
        $.fn.select2.defaults.set('language', 'fr');
        $filtreAgence.select2({
            placeholder: $filtreAgence.data('agencetype')+' ...',
            allowClear: true,
            width: '280px',
        });
        $('.select2-container').addClass('form-control');

        // chargement de liste des agences au chargement de la page
        updateListeAgence();

        $filtreAgence.on('change', function(evt) {
            sessionStorage['table-candidats-locataires.filtre-agence'] = evt.target.value;
            $('table').bootstrapTable('refresh');
        });

        // Au changement du département, on change la liste d'agences
        $filtreDepartement.on('change', function(evt) {
            sessionStorage['table-candidats-locataires.filtre-departement'] = evt.target.value;
            updateListeAgence();
            $('table').bootstrapTable('refresh');
        });

        // Filtre Agent
        if ($filtreAgent.length) {
            if (sessionStorage['table-candidats-locataires.filtre-agent']) {
                $filtreAgent.val(sessionStorage['table-candidats-locataires.filtre-agent']);
            }
            $filtreAgent.on('change', function (evt) {
                sessionStorage['table-candidats-locataires.filtre-agent'] = evt.target.value;
                $('table').bootstrapTable('refresh');
            });
        }

        // Filtre Actif
        if (sessionStorage['table-candidats-locataires.filtre-actif']) {
            $filtreActif.val(sessionStorage['table-candidats-locataires.filtre-actif']);
        }
        $filtreActif.on('change', function(evt) {
            sessionStorage['table-candidats-locataires.filtre-actif'] = evt.target.value;
            $('table').bootstrapTable('refresh');
        });

        // Filtre `Archivé ...`
        if (sessionStorage['table-candidats-locataires.filtre-archive']) {
            $filtreArchive.val(sessionStorage['table-candidats-locataires.filtre-archive']);
        }
        $filtreArchive.on('change', function(evt) {
            sessionStorage['table-candidats-locataires.filtre-archive'] = evt.target.value;
            $('table').bootstrapTable('refresh');
        });

        // Filtre `Statut ...`
        if (sessionStorage['table-candidats-locataires.filtre-statut']) {
            $filtreStatut.val(sessionStorage['table-candidats-locataires.filtre-statut']);
        }
        $filtreStatut.on('change', function(evt) {
            sessionStorage['table-candidats-locataires.filtre-statut'] = evt.target.value;
            $('table').bootstrapTable('refresh');
        });

        // Filtre `Origine du candidat ...`
        if (sessionStorage['table-candidats-locataires.filtre-origine']) {
            $filtreOrigineCandidat.val(sessionStorage['table-candidats-locataires.filtre-origine']);
        }
        $filtreOrigineCandidat.on('change', function(evt) {
            sessionStorage['table-candidats-locataires.filtre-origine'] = evt.target.value;
            $('table').bootstrapTable('refresh');
        });

        // Filtre `Bail élec ...`
        if (sessionStorage['table-candidats-locataires.filtre-bailelec']) {
            $filtreBailElec.val(sessionStorage['table-candidats-locataires.filtre-bailelec']);
        }
        $filtreBailElec.on('change', function(evt) {
            sessionStorage['table-candidats-locataires.filtre-bailelec'] = evt.target.value;
            $('table').bootstrapTable('refresh');
        });

        if ($filtreGliZelok.length) {
            // Filtre `GLI ZELOK...`
            if (sessionStorage['table-candidats-locataires.filtre-glizelok']) {
                $filtreGliZelok.val(sessionStorage['table-candidats-locataires.filtre-glizelok']);
            }
            $filtreGliZelok.on('change', function (evt) {
                sessionStorage['table-candidats-locataires.filtre-glizelok'] = evt.target.value;
                $('table').bootstrapTable('refresh');
            });
        }

        if ($filtreReseau.length) {
            // Filtre `Reseau ...`
            if (sessionStorage['table-candidats-locataires.filtre-reseau']) {
                $filtreReseau.val(sessionStorage['table-candidats-locataires.filtre-reseau']);
            }
            $filtreReseau.on('change', function (evt) {
                sessionStorage['table-candidats-locataires.filtre-reseau'] = evt.target.value;
                $('table').bootstrapTable('refresh');
            });
        }

    }

    function updateListeAgence()
    {
        var idAgenceSelectionne = $filtreAgence.val() ? $filtreAgence.val() : agenceSelectionnee;
        var deptNum = $filtreDepartement.val();

        var data = {
            idDepartement: deptNum,
        };
        $.get('ajax/getAgences', data, function (data) {
            var agences = data.msg;

            $filtreAgence.empty();

            var optAgence = new Option();
            optAgence.value = '';
            $filtreAgence.append(optAgence);

            $.each(agences, function(key, agence) {
                var opt = new Option();
                opt.value = agence.agence_numero;
                opt.text  =  agence.agence_numero + ' - ' + agence.raison_sociale;
                opt.selected = agence.agence_numero === idAgenceSelectionne;
                $filtreAgence.append(opt);
            });

            if (sessionStorage['table-candidats-locataires.filtre-agence']) {
                $filtreAgence.val(sessionStorage['table-candidats-locataires.filtre-agence']).trigger("change");
            }

        }, 'json');
    }


    return {
        init: init,
    };

}();
